import UIComponent from "../../common/UIComponent";
import "./index.css";
export default class H5FullScreenBtn extends UIComponent {

  constructor(elementId, interfaces) {
    super()
    this.elementId = elementId;
    this.interfaces = interfaces;
    this.init();
  }

  init() {

    this.h5fullscreenBtn = document.createElement("span");
    this.h5fullscreenBtn.setAttribute("class", "vhallPlayerh5-fullscreenBtn");
    this.h5fullscreenBtn.onclick = this.handlerBtnClick.bind(this);

    this.appendChild(this.elementId, this.h5fullscreenBtn);
  }


  handlerBtnClick(){
    if(this.interfaces.isFullscreen()){
      this.interfaces.exitFullScreen();
    }else{
      this.interfaces.enterFullScreen();
    }
  }

}